import { Box, Typography } from "@mui/material";
import { ReactNode, SVGProps } from "react";

export const EmptyDataView = ({ message, img }: { message: string; img?: ReactNode }) => {
    return (
        <Box p={2} m={"auto"} width={"fit-content"}>
            <Box margin={"auto"} width={"fit-content"}>
                {img !== undefined ? img : <SvgIlluKeinedaten />}
            </Box>
            <Box pt={3} maxWidth={"411px"}>
                <Typography variant={"h4"} align={"center"}>
                    {message}
                </Typography>
            </Box>
        </Box>
    );
};
const SvgIlluKeinedaten = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={192} height={128} fill="none" {...props}>
        <path
            fill="#F3EFEC"
            d="M0 20.081C0 8.991 8.99 0 20.081 0h126.775c9.907 0 17.938 8.03 17.938 17.937v4.334c0 7.513 6.09 13.604 13.603 13.604S192 41.965 192 49.478v36.506c0 11.09-8.991 20.081-20.081 20.081H82.438c-6.892 0-12.478-5.587-12.478-12.479 0-6.891-5.587-12.478-12.479-12.478h-37.4C8.991 81.108 0 72.118 0 61.028V20.08Z"
        />
        <path
            fill="#FDC2B2"
            d="M14.995 31.06h8.8c3.203 0 5.786-2.728 5.786-6.11 0-3.384-2.583-6.112-5.786-6.112h-8.8c-3.203 0-5.786 2.728-5.786 6.111 0 3.383 2.6 6.112 5.786 6.112ZM104.576 48.364a7.157 7.157 0 0 1 7.157-7.157h27.481a7.156 7.156 0 0 1 0 14.313h-27.481a7.157 7.157 0 0 1-7.157-7.156Z"
        />
        <rect width={67.355} height={5.421} x={109.938} y={100.643} fill="#E2491B" rx={2.711} />
        <mask
            id="illu-keinedaten_svg__a"
            width={58}
            height={77}
            x={115}
            y={24}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: "alpha",
            }}
        >
            <path fill="#E6673B" d="M139.827 27.237c1.338-4.013 7.014-4.013 8.351 0l24.47 73.408h-57.291l24.47-73.408Z" />
        </mask>
        <g mask="url(#illu-keinedaten_svg__a)">
            <path fill="#E2491B" d="M139.875 27.179c1.341-4.006 7.007-4.006 8.348 0l24.518 73.246h-57.384l24.518-73.246Z" />
            <path fill="#D9D9D9" d="M139.962 32.95c.15-.494.879-.371.86.144l-2.408 65.347H120.01l19.952-65.492Z" opacity={0.4} />
            <path fill="#fff" d="M118.752 66.391h49.869v17h-49.869zM118.752 35.79h49.869v17h-49.869z" />
        </g>
        <path fill="#E2491B" d="M113.807 99.343c0-.412.334-.746.746-.746h58.895c.412 0 .746.334.746.746v1.578h-60.387v-1.578Z" />
        <rect
            width={67.355}
            height={5.421}
            x={46.164}
            y={30.891}
            fill="#E2491B"
            rx={2.711}
            transform="rotate(114.48 46.164 30.89)"
        />
        <mask
            id="illu-keinedaten_svg__b"
            width={83}
            height={62}
            x={20}
            y={35}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: "alpha",
            }}
        >
            <path fill="#E6673B" d="M100.587 88.51c3.098 2.88.746 8.047-3.46 7.601l-76.95-8.148 23.74-52.14 56.67 52.688Z" />
        </mask>
        <g mask="url(#illu-keinedaten_svg__b)">
            <path fill="#E2491B" d="M100.619 88.579c3.09 2.88.743 8.036-3.459 7.597L20.34 88.139l23.778-52.225 56.502 52.665Z" />
            <path
                fill="#D9D9D9"
                d="M95.472 86.064c.387.34-.027.954-.488.724L36.51 57.517l7.626-16.75 51.337 45.296Z"
                opacity={0.4}
            />
            <path
                fill="#fff"
                d="M73.687 53.104 53.023 98.49 37.55 91.446 58.215 46.06zM101.535 65.785 80.87 111.17l-15.472-7.045L86.063 58.74z"
            />
        </g>
        <path
            fill="#E2491B"
            d="M45.803 34.82c.375.171.541.614.37.989l-24.404 53.6a.746.746 0 0 1-.988.37l-1.436-.653 25.023-54.96 1.435.654Z"
        />
    </svg>
);
